<script lang="ts">
	export let fill = "";

</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 20 20">
	<path
		data-name="패스 20815"
		d="M54.709 346.672a10 10 0 1 0 10 10 10 10 0 0 0-10-10zm-.009 4.871a.4.4 0 0 1 .4.4l.017 7.44a.4.4 0 1 1-.8 0l-.017-7.44a.4.4 0 0 1 .4-.4zm.009 10.658a.418.418 0 1 1 .418-.418.418.418 0 0 1-.418.417z"
		transform="translate(-44.709 -346.672)"
		style={`fill : ${fill}`} />
</svg>

<style lang="scss">
	path {
		fill: #bcbfc3;
	}

</style>
